<template>
  <div>
    <div class="succ_">
      <img class="img_" src="../../../assets/image/invite/success.png" alt="" />
      <h1 class="h1_">
        注册成功
      </h1>
      <h1 class="h1_">
        登录账号: {{info.adminUsername}}
      </h1>

      <p style="margin-top: 40px;">平台使用方法：</p>
      <p>一、电脑端登录nyboss.ssish.com</p>
      <p>二、关注、绑定【保思】公众号在线投保</p>
      <img class="code_" src="../../../assets/image/nsale/wechatCode.png" alt="">
      <img class="code_" src="../../../assets/image/nsale/kefuCode.png" alt="">
    </div>
  </div>
</template>

<script>
import common from "./common.js";
export default {
  data() {
    return {
      info:{}
    };
  },
  mounted() {
    this.info = this.getSession('l_')
  },
  methods: {
    ...common,
  }
};
</script>

<style scoped lang="scss">
.succ_ {
  font-size: 0.4rem;
  font-family: PingFang SC;
  padding-top: 0.39rem;
  .h1_ {
    color: rgba(51, 51, 51, 1);
    margin: 0 auto 0.39rem;
    font-size: 0.4rem;
    font-weight: bold;
  }
  .img_ {
    height: 1.95rem;
    width: auto;
    margin: 10px auto;
  }
  p{
    font-size: 14px;
    text-align: left;
    margin: 10px 20px;
  }
  .code_{
    width:300px;
    height: auto;
    margin:10px auto;
  }
}
.btn_ {
  margin: 0 15px;
  margin-top: 3.67rem;
  height: 1.33rem;
  background: #1b7cf8;
  border-radius: 0.67rem;
  line-height: 50px;
  border-radius: 25px;
  font-size: 15px;
  color: rgba(255, 255, 255, 1);
}
.txt_ {
  font-size: 0.35rem;
  color: #666666;
}
.bold_ {
  font-weight: bold;
}
.mar_20 {
  margin: 20px 0;
}
.mar_100 {
  margin: 100px 0;
}
</style>
